import { cva } from 'class-variance-authority';
import { cn } from 'common/utils';
import React from 'react';

const chipVariants = cva(
  'inline-flex items-center gap-1 rounded-md px-2.5 py-1 text-xs cursor-default',
  {
    variants: {
      variant: {
        primary: 'text-vibrant-orange bg-vibrant-orange/20',
        grey: 'text-cool-grey bg-cool-grey/20',
        secondary: '',
        success: 'text-success-green bg-success-green/20',
        warning: 'text-warning-yellow bg-warning-yellow/20',
        alert: 'text-alert-red bg-alert-pink/20',
        'primary-outlined':
          'border border-vibrant-orange text-vibrant-orange bg-vibrant-orange/5',
        'grey-outlined':
          'border border-granite-grey text-granite-grey bg-platinum-grey/20',
        'secondary-outlined':
          'border border-soft-blue text-soft-blue bg-soft-blue/5',
        'alt-secondary-outlined':
          'border border-action-blue text-action-blue bg-frost-blue/20',
        'success-outlined':
          'border border-success-green text-success-green bg-success-green/5',
        'alt-success-outlined':
          'border border-success-green text-success-green bg-success-mint/20',
        'warning-outlined':
          'border border-warning-yellow text-warning-yellow bg-warning-yellow/5',
        'alt-warning-outlined':
          'border border-amber-warning text-amber-warning bg-amber-light/20',
        'alert-outlined':
          'border border-alert-red text-alert-red bg-alert-pink/20',
        'primary-light': 'text-vibrant-orange px-0 py-0',
        'success-light': 'text-success-green px-0 py-0',
        'warning-light': 'text-warning-yellow px-0 py-0',
        'alert-light': 'text-alert-red px-0 py-0',
        'dropdown-outlined':
          'border border-cool-grey text-sonic-silver text-sm uppercase px-4 py-1.5 cursor-pointer',
        'dropdown-outlined-light':
          'border border-bright-grey text-sonic-silver text-sm uppercase px-4 py-1.5 cursor-pointer',
        'input-outlined':
          'border border-dark-blue outline-dark-blue text-dark-blue bg-white rounded-md px-4 py-2 text-md',
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  },
);

const Chip = ({ className, variant, ...props }) => {
  return (
    <div className={cn(chipVariants({ variant }), className)} {...props} />
  );
};

export default Chip;
